import { Component, ElementRef, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { messages as i18n } from '@teem/constants/messages';

@Component({
  selector: 'app-quotation-link-modal',
  templateUrl: './quotation-link-modal.component.html',
  styles: []
})
export class QuotationLinkModalComponent {

  @Input() quotationUrl;

  constructor(
    public activeModal: NgbActiveModal,
    private el: ElementRef
  ) { }

  copyLink(inputElement?: any) {
    try {
      inputElement.select();
      (document as any).execCommand('copy');
      inputElement.setSelectionRange(0, 0);

      Swal.fire(i18n.done, i18n.quote.quote_copied_to_clipboard, 'success');
    } catch (err) {
      console.error(err);
    }
  }
}
